import React, { FC, useContext, useMemo } from 'react'
import styled from 'styled-components'
import SessionContext from '../SessionContext'

const StyledFrameWrapper = styled.div`
  background: #ffffff;
  box-shadow: 0 6px 24px -6px #d7d7d9;
  border-radius: 4px;
  margin: 20px 0 0;
`

const AdBanner: FC = () => {
  const {
    currentDealer: { invite_code },
  } = useContext(SessionContext)

  const ts = useMemo(() => {
    return Date.now()
  }, [invite_code])

  if (!invite_code) return <></>

  return (
    <StyledFrameWrapper>
      <iframe
        src={`https://widget.viadelivery.pro/event/?invite_code=${invite_code}&ts=${ts}`}
        // src={`/ad-banner/index.html/?invite_code=${invite_code}`}
        frameBorder="0"
        width="100%"
        height={450}
        scrolling="no"
      />
    </StyledFrameWrapper>
  )
}

export default AdBanner
